<div class="sidebar" [ngClass]="mobile ? 'sidebar-mobile' : 'sidebar-desktop'">

  <!-- Navigation menus -->
  @for (section of sidebarLayout.sections; track section) {
    @if (section.accessRights === 'public'
      || (section.accessRights === 'authOnly' && auth.tokenUser)
      || (section.accessRights === 'adminOnly' && auth.tokenUser && auth.tokenUser.access_level >= 4)) {
      <div class="sidebar-section">
        <h3 class="sidebar-section-header">{{section.translate === false ? section.title : (section.title | translate)}}</h3>
        @for (topLevel of section.items; track topLevel) {
          <ul class="first-level-nav">
            <!-- Top level link with a submenu -->
            @if (topLevel.items) {
              <li routerLinkActive="active">
                <!-- Top Level link -->
                <a class="sidebar-link" routerLinkActive="active" (click)="toggleCollapse(topLevel.id)">
                  <fa-icon [icon]="topLevel.icon" class="nav-icon"></fa-icon>
                  <span>{{topLevel.translate === false ? topLevel.title : (topLevel.title | translate)}}</span>
                  @if (topLevel.items && !collapsedStates[topLevel.id]) {
                    <fa-icon icon="angle-down" class="caret"></fa-icon>
                  }
                  @if (topLevel.items && collapsedStates[topLevel.id]) {
                    <fa-icon icon="angle-right" class="caret"></fa-icon>
                  }
                </a>
                <!-- Submenu -->
                <ul [ngbCollapse]="collapsedStates[topLevel.id].isCollapsed" class="second-level-nav">
                  @for (secondLevel of topLevel.items; track secondLevel) {
                    @if (!secondLevel.accessRights
                      || (secondLevel.accessRights === 'authOnly' && auth.tokenUser)
                      || (secondLevel.accessRights === 'adminOnly' && auth.tokenUser && auth.tokenUser.access_level >= 4)) {
                      <li routerLinkActive="active">
                        <a [routerLink]="secondLevel.routerLink">{{secondLevel.translate === false ? secondLevel.title : (secondLevel.title | translate)}}</a>
                      </li>
                    }
                  }
                </ul>
              </li>
            }
            <!-- Single top level link with no submenu -->
            @if (!topLevel.items) {
              <li routerLinkActive="active">
                <a [routerLink]="topLevel.routerLink" class="sidebar-link">
                  <fa-icon [icon]="topLevel.icon" class="nav-icon"></fa-icon>
                  {{topLevel.translate === false ? topLevel.title : (topLevel.title | translate)}}
                </a>
              </li>
            }
          </ul>
        }
      </div>
    }
  }

  <!-- Custom content -->
  <ng-content></ng-content>


  <!-- Language Secttion -->
  @if (showTranslationDropdown) {
    <div ngbDropdown>
      <div class="language-select" id="languageSelect" ngbDropdownToggle>
        <!--<img src="/spotter-shared/flag-icons/{{lang}}.svg">-->
        <fa-icon icon="language"></fa-icon>{{this.languageService.language.name}}
      </div>
      <ul ngbDropdownMenu aria-labelledby="languageSelect" class="dropdown-menu dropdown-menu-left language-selections">
        @for (lang of this.languageService.languages; track lang) {
          <li>
            @if (lang.live) {
              <a class="dropdown-item" [ngClass]="lang.name == this.languageService.language.name ? 'active' : ''" (click)="switchLanguage(lang.code)">{{lang.name}}</a>
            }
          </li>
        }
      </ul>
    </div>
  }
</div>